import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBannerAlt from '../../components/PageIntroBannerAlt';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';
import ContactMenu from '../ContactUs/ContactMenu';

function CustomerCare({ page }) {
  if (!page) {
    return null;
  }

  return (
    <div>
      <InsideHeader h1="Customer Care" background={page.page_image.contentUrl} />
      <PageHelmet page={page} />
      <Header />
      <ContactMenu />
      <div className="container">
        <div className="row">
          <div className="col-lg-9 order-lg-2">
            <PageIntroBannerAlt
              h2={get(page, 'intro_banner[0].main_headline')}
              p={get(page, 'intro_banner[0].paragraph')}
              background={get(page, 'intro_banner[0].photo.contentUrl')}
            />
            {
              page.page_section.map(item => (
                <section key={item.headline} className="section-pd section-alternate">
                  <div className="full-width-headline-left">
                    <div className="container">
                      <h3>{item.headline}</h3>
                    </div>
                    <div className="lines" />
                  </div>
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12" dangerouslySetInnerHTML={SanitizeHtml(item.text)} />
                    </div>
                  </div>
                </section>
              ))
            }
          </div>
          <div className="col-lg-3 order-lg-1">
            <div className="side-page-column">
              <section>
                <h4>PDF Downloads & Links</h4>
                {
                  page.pdf_brochures.map(item => (
                    <a
                      href={item.link || get(item, 'pdf.contentUrl')}
                      key={item.title}
                      className="btn btn-block btn-2"
                      target="_blank"
                    >
                      {item.title}
                    </a>
                  ))
                }
                <Link name="service-request" className="btn btn-block">Service Request Form</Link>
              </section>
              {
                get(page, 'call_centers') &&
                <section>
                  <h4>Direct Contact Wilmington Market</h4>
                  <ul className="list-unstyled">
                    {
                      get(page, 'call_centers').map(callCenter => (
                        <li key={callCenter.area}>
                          <span>{callCenter.area}</span><br />
                          {callCenter.phone_number}
                        </li>
                      ))
                    }
                  </ul>
                </section>
              }
              {
                get(page, 'twenty_four_hour_hotlines') &&
                <section>
                  <h4>Direct Contact Jacksonville Market</h4>
                  <ul className="list-unstyled">
                    {
                      get(page, 'twenty_four_hour_hotlines').map(callCenter => (
                        <li key={callCenter.area}>
                          <span>{callCenter.area}</span><br />
                          {callCenter.phone_number}
                        </li>
                      ))
                    }
                  </ul>
                </section>
              }
            </div>
          </div>
        </div>
      </div>
      <CtaBanner />
      <TestimonialBanner />
      <Footer />
    </div>
  );
}

CustomerCare.propTypes = {
  page: PropTypes.object,
};

CustomerCare.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'customer_care',
})(CustomerCare);



// WEBPACK FOOTER //
// ./src/pages/CustomerCare/index.js